export default "__VITE_ASSET__BQJLHEbu__"